export const vatEnabledCountries = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
  'AU',
];

export const postalEnabledCountries = [
  'US',
  'CA',
  'PR',
  'GU',
  'AS',
  'MH',
  'VI',
  'FM',
  'MP',
  'PW',
];

export const postalCodeErrors = [
  'InvalidAddress',
  'StringLengthError',
  'GetTaxError',
];

export const vatErrors = [
  'InvalidVat',
];
